<template>
  <div>
    <div class="inline-flex pb-6">
      <h1 class="inline-flex pr-4">
        FDMS Outbound Service Component
        <p class="pl-4">|</p>
      </h1>
      <p class="pr-4"></p>
      <vs-button color="#5b3cc4" type="filled" icon="search" @click="regrid"
        >List</vs-button
      >
      <p class="pr-4"></p>
      <vs-dropdown>
        <vs-button
          class="btn-drop"
          type="filled"
          icon="more_horiz"
          color="success"
          v-if="btndis"
          >Action</vs-button
        >

        <vs-dropdown-menu>
          <vs-dropdown-item @click="goPick">/inbound-permit</vs-dropdown-item>
          <vs-dropdown-item @click="goPickMain"
            >/zone3-confirm-out</vs-dropdown-item
          >
          <!--<vs-dropdown-item @click="goPickMainPrint"
            >Pick Print</vs-dropdown-item
          >
          <vs-dropdown-item @click="goShip">Ship Main</vs-dropdown-item> -->
        </vs-dropdown-menu>
      </vs-dropdown>
      <!-- <vs-dropdown>
        <vs-button
          class="btn-drop"
          type="filled"
          icon="unarchive"
          color="success"
          v-if="btndis2"
          >Confirm Out</vs-button
        >

        <vs-dropdown-menu>
          <vs-dropdown-item @click="goSystem">All</vs-dropdown-item>
          <vs-dropdown-item @click="goAllocate">By Allocate</vs-dropdown-item>
          <vs-dropdown-item @click="goPrint">Print</vs-dropdown-item>
        </vs-dropdown-menu>
      </vs-dropdown> -->
      <!-- <p class="pr-4"></p>
      <vs-button
        color="warning"
        type="filled"
        icon="done_all"
        @click="btnMatch"
        v-if="btndis"
      >Matching</vs-button> 
      <p class="pr-4"></p>
      <vs-button
        class="btn-drop"
        type="filled"
        icon="navigate_before"
        color="danger"
        @click="goBack"
        >Back</vs-button
      >
      <p class="pr-4"></p>-->

      <!-- <div class="fab-wrapper" :style="fabStyle" v-if="btndis">
        <vs-dropdown vs-trigger-click class="cursor-pointer">
          <div class="fab p-8 rounded-full cursor-pointer flex items-center justify-between">
            <feather-icon icon="ChevronUpIcon" svgClasses="h-4 w-4" />
          </div>
         <vs-dropdown-menu>
            <vs-dropdown-item
              v-for="fab in fabact"
              :key="fab.act"
              @click="handle_function_call(fab.act)"
            >
              <span>{{fab.label}}</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div> -->
    </div>

    <transition-group
      enter-active-class="animated lightSpeedIn"
      leave-active-class="animated lightSpeedOut"
    >
      <exbdadd
        v-if="addshow"
        :key="addshow"
        :masrec="masrec"
        :acstate="acstate"
        :recid="recid"
        @grid="grid"
      ></exbdadd>
      <exberror v-if="errorshow" key="errorshow" :errdata="errdata"></exberror>
      <aggrid
        v-if="gridshow"
        :key="gridshow"
        :masrec="masrec"
        @recsel="recsel"
        :companyGroupsCode="companyGroupsCode"
        @mousedown.middle.native="getXY"
      ></aggrid>
      <aggrid2
        v-if="gridshow2"
        :key="gridshow2"
        :masrec="masrec"
        @recsel2="recsel2"
        :companyGroupsCode="companyGroupsCode"
      ></aggrid2>
    </transition-group>
  </div>
</template>

<script>
// import aggrid from "./DataTable/AgGrid";
import aggrid from "./grid.vue";
// import aggrid2 from "./DataTableMatch/AgGrid";
import aggrid2 from "./grid.vue";
import exbdadd from "./exbdadd";
import exberror from "./exberror";
import moment from "moment";
import pdfMake from "pdfmake";
import pdfFonts from "../../../assets/custom-fonts";

import axios from "axios";
import {
  BASE_API_URL,
  PROX_URL,
  NETBAY_URL,
  ENV_CHECK,
} from "@/constants/index.ts";

export default {
  data() {
    return {
      arData: [],
      walletId: "",
      userid: "",
      businessPartnersCode: "",
      companyGroupsCode: "",
      pickOrdersNumber: "",
      exbordersNumber: "",
      addshow: false,
      gridshow: false,
      gridshow2: false,
      errshow: false,
      errorshow: false,
      btndis: false,
      btndis2: false,
      comUpload: false,
      recid: "0",
      recid2: "0",
      curX: null,
      curY: null,
      acstate: null,
      masrec: null,
      errdata: null,
      fabact: [
        { act: "cusAdd", label: "Add" },
        { act: "cusEdit", label: "Edit" },
        { act: "cusDel", label: "Delete" },
        { act: "goSystem", label: "PickBySystem" },
        { act: "goPrint", label: "PrintPicking" },
        { act: "hideFab", label: "Hide" },
      ],
    };
  },
  computed: {
    fabStyle: function () {
      return {
        left: this.curX + "px",
        top: this.curY + "px",
      };
    },
  },
  methods: {
    formatnumber(number) {
      return number.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },
    cvDate(date) {
      let d = new Date(date);
      let dformat =
        [d.getDate(), d.getMonth() + 1, d.getFullYear()].join("/") +
        " " +
        [d.getHours(), d.getMinutes(), d.getSeconds()].join(":");
      return dformat;
    },
    getArrayPick(data) {
      // console.log(data);
      this.arData = [];

      let i = 1;

      data.forEach((item) => {
        // item.updated_at = item.updated_at
        //   ? item.updated_at.replace(/-/g, "/")
        //   : null;
        this.arData.push([
          {
            text: i,
            fontSize: 10,
            bold: false,
            alignment: "center",
          },
          {
            text: item.exbordersNumber,
            fontSize: 10,
            bold: false,
            alignment: "center",
          },
          {
            text: item.inbordersnumber,
            fontSize: 10,
            bold: false,
            alignment: "center",
          },
          {
            text: item.inbitemnum,
            fontSize: 10,
            bold: false,
            alignment: "center",
          },
          {
            text: item.inbdetailsSkuscode,
            fontSize: 10,
            bold: false,
            alignment: "center",
          },
          {
            text: item.hawb,
            fontSize: 10,
            bold: false,
            alignment: "center",
          },
          {
            text: item.edescription,
            fontSize: 10,
            bold: false,
            alignment: "center",
          },
          {
            text:
              this.formatnumber(item.itempck) +
              "/" +
              this.formatnumber(item.totalpck),
            fontSize: 10,
            bold: false,
            alignment: "right",
          },
          {
            text: item.packagesCode,
            fontSize: 10,
            bold: false,
            alignment: "center",
          },
          {
            text: item.locationsCode,
            fontSize: 10,
            bold: false,
            alignment: "center",
          },
          {
            text: this.cvDate(item.createdAt),
            fontSize: 10,
            bold: false,
            alignment: "center",
          },
          {
            text: item.tmotypesCode,
            fontSize: 10,
            bold: false,
            alignment: "center",
          },
        ]);

        i++;
        // console.log(i);
      });
    },
    async goPickMainPrint() {
      try {
        const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

        this.loading = true;

        if (token) {
          const formData = {
            companyGroupsCode: this.companyGroupsCode,
            number: this.recid,
            editor: this.userid,
            // from: '2022-01-11'
          };
          // const response = await axios.post(`${BASE_API_URL}/agents/findall`, formData);

          const response = await axios.post(
            `${BASE_API_URL}/outbound-svc/picks/picksPrintOutbound`,
            formData,
            {
              headers: { Authorization: "Bearer " + token.accessToken },
            }
          );

          if (response.data.status != "success") {
            this.loading = false;
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Error",
              text: response.data.message,
            });
          } else {
            // console.log(response.data);

            this.getArrayPick(response.data.pickDetails);

            const docDefinition = {
              // a string or { width: number, height: number }
              pageSize: "A4",

              // by default we use portrait, you can change it to landscape if you wish
              pageOrientation: "landscape",
              footer: (currentPage, pageCount) => {
                return {
                  columns: [
                    {
                      text: [
                        {
                          text:
                            "ผู้จัดทำเอกสาร " +
                            response.data.editor +
                            "\t\t\t\t\t\t\t",
                          fontSize: 14,
                        },

                        {
                          text:
                            "ผู้ส่งมอบ______________________" +
                            "\t\t\t\t\t\t\t",
                          fontSize: 14,
                        },
                        {
                          text:
                            "ผู้รับมอบ______________________" +
                            "\t\t\t\t\t\t\t",
                          fontSize: 14,
                        },
                        {
                          text:
                            "พิมพ์ ณ วันที่ " + this.cvDate(new Date()) + "\n",
                          fontSize: 14,
                        },
                        {
                          text:
                            "Page " +
                            currentPage.toString() +
                            " / " +
                            pageCount +
                            "\t\t",
                        },
                      ],
                      alignment: "center",
                    },
                  ],
                };
              },

              content: [
                {
                  text: "ใบสั่งการนำสินค้าออกจากคลังสินค้า",
                  style: "title",
                  // [left, top, right, bottom]
                  margin: [0, -20, 0, 0],
                },
                {
                  text: "ใบนำสินค้าออกเลขที่ " + response.data.picksNumber,
                  style: "subtitle",
                  margin: [0, 0, 0, 10],
                },
                {
                  table: {
                    // headers are automatically repeated if the table spans over multiple pages
                    // you can declare how many rows should be treated as headers
                    headerRows: 1,
                    widths: [30, 50, 60, 30, 120, 60, 80, 45, 35, 60, 60, 60], // 525(portrait) 700(landscape)
                    body: [
                      [
                        {
                          text: "ลำดับ",
                          bold: true,
                          fontSize: 10,
                          alignment: "center",
                        },
                        {
                          text: "Outbound Number",
                          bold: true,
                          fontSize: 10,
                          alignment: "center",
                        },
                        {
                          text: "Inbound Number",
                          bold: true,
                          fontSize: 10,
                          alignment: "center",
                        },
                        {
                          text: "Inbound Item",
                          bold: true,
                          fontSize: 10,
                          alignment: "center",
                        },
                        {
                          text: "Product Code",
                          bold: true,
                          fontSize: 10,
                          alignment: "center",
                        },
                        {
                          text: "HAWB",
                          bold: true,
                          fontSize: 10,
                          alignment: "center",
                        },
                        {
                          text: "Description",
                          bold: true,
                          fontSize: 10,
                          alignment: "center",
                        },
                        {
                          text: "Package",
                          bold: true,
                          fontSize: 10,
                          alignment: "center",
                        },
                        {
                          text: "UNIT",
                          bold: true,
                          fontSize: 10,
                          alignment: "center",
                        },
                        {
                          text: "Location",
                          bold: true,
                          fontSize: 10,
                          alignment: "center",
                        },
                        {
                          text: "Order Pick At",
                          bold: true,
                          fontSize: 10,
                          alignment: "center",
                        },
                        {
                          text: "Type",
                          bold: true,
                          fontSize: 10,
                          alignment: "center",
                        },
                      ],
                    ],
                  },
                },
                {
                  table: {
                    heights: 15,
                    widths: [30, 50, 60, 30, 120, 60, 80, 45, 35, 60, 60, 60], // 525(portrait) 700(landscape)
                    // body: this.getArray(res.data.message),
                    body: this.arData,
                    // body: [[{}, {},{}, {}, {}, {},{}, {}, {}]],
                  },
                },
                {
                  table: {
                    heights: 15,
                    widths: [30, 50, 60, 30, 120, 60, 80, 45, 35, 60, 60, 60], // 525(portrait) 700(landscape)
                    body: [
                      [
                        {},
                        {},
                        {},
                        {},
                        {},
                        {},
                        {
                          text: "Total Packages",
                          bold: true,
                          fontSize: 10,
                          alignment: "center",
                        },
                        {
                          text: this.formatnumber(response.data.sumpck),
                          bold: true,
                          fontSize: 10,
                          alignment: "center",
                        },
                        {},
                        {},
                        {},
                        {},
                      ],
                    ],
                  },
                },
              ],
              defaultStyle: {
                // 4. default style 'THSarabunNew' font to test
                font: "THSarabunNew",
              },
              styles: {
                title: {
                  fontSize: 18,
                  bold: true,
                  alignment: "center",
                },
                subtitle: {
                  fontSize: 16,
                  bold: true,
                  alignment: "center",
                },
                header: {
                  fontSize: 18,
                  bold: true,
                  alignment: "right",
                  margin: [0, 190, 0, 80],
                },
                subheader: {
                  fontSize: 14,
                },
                superMargin: {
                  margin: [20, 0, 40, 0],
                  fontSize: 15,
                },
              },
            };

            pdfMake.vfs = pdfFonts.pdfMake.vfs; // 2. set vfs pdf font
            pdfMake.fonts = {
              // default Roboto font
              Roboto: {
                normal: "Roboto-Regular.ttf",
                bold: "Roboto-Medium.ttf",
                italics: "Roboto-Italic.ttf",
                bolditalics: "Roboto-MediumItalic.ttf",
              },
              // THSarabunNew Font
              THSarabunNew: {
                normal: "THSarabunNew.ttf",
                bold: "THSarabunNew Bold.ttf",
                italics: "THSarabunNew italic.ttf",
                bolditalics: "THSarabunNew Bolditalic.ttf",
              },
            };

            setTimeout(() => {
              pdfMake.createPdf(docDefinition).open();
            }, 1000);

            this.$vs.notify({
              position: "top-right",
              color: "success",
              title: "Print Complete",
              text: "Print Complete",
            });
          }
        }
      } catch (error) {
        this.data = [];
        this.total = 0;
        this.loading = false;
        // throw error;
        alert("กรุณาเข้าระบบอีกครั้ง");
        // await this.$router.replace("/pages/login/");
      }
    },
    btnMatch() {
      // console.log("Matching");
      this.gridshow = false;
      this.gridshow2 = true;
      this.btndis = false;
    },
    handle_function_call(function_name) {
      this[function_name]();
    },
    recsel(val, val2) {
      this.btndis = true;
      this.recid = val;
      // console.log(this.recid);
      this.exbordersNumber = val2;
    },
    recsel2(val) {
      this.btndis = true;
      this.recid = val;
      // console.log(this.recid2);
    },
    cusAdd() {
      this.recid = 0;
      this.addshow = true;
      this.gridshow = false;
      this.gridshow2 = false;
      this.btndis = false;
      this.errshow = false;
      this.acstate = "ADD";
    },
    grid() {
      this.addshow = false;
      this.gridshow = true;
      this.btndis = false;
      this.errshow = false;
      this.$store.dispatch("setReportGrid", 0);
    },
    goBack() {
      this.addshow = false;
      this.gridshow2 = false;
      this.gridshow = true;
      this.btndis = false;
      this.errshow = false;
    },
    goSystem() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Do you want to Picking? ",
        accept: this.goSystemPick,
      });
    },
    async goSystemPick() {
      try {
        const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));
        this.readonly = true;

        if (token) {
          const formData = {
            number: this.recid,
            editor: String(this.userid),
            companyGroupsCode: this.companyGroupsCode,
          };

          const response = await axios.post(
            `${BASE_API_URL}/outbound-svc/exbdetails/exbCnpick`,
            formData,
            {
              headers: { Authorization: "Bearer " + token.accessToken },
            }
          );
          // console.log(response.data);

          if (response.data.status != "success") {
            this.loading = false;
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Error from Backend",
              text: response.data.message,
            });

            this.errdata = response.data.errdata;
            this.errorshow = true;
          } else {
            this.$vs.notify({
              position: "top-right",
              color: "success",
              title: "exbCnpick Complete",
              text: response.data.message,
            });
            this.pickOrdersNumber = response.data.picknum;

            const formData2 = {
              number: response.data.pickdetail[0].number,
              editor: String(this.userid),
              companyGroupsCode: this.companyGroupsCode,
            };

            const response2 = await axios.post(
              `${BASE_API_URL}/outbound-svc/exbdetails/cnPick`,
              formData2,
              {
                headers: { Authorization: "Bearer " + token.accessToken },
              }
            );
            // console.log(response2.data);

            if (response2.data.status != "success") {
              this.loading = false;
              this.$vs.notify({
                position: "top-right",
                color: "danger",
                title: "Error from Backend",
                text: response2.data.message,
              });

              this.errdata = response2.data.errdata;
              this.errorshow = true;
            } else {
              this.$vs.notify({
                position: "top-right",
                color: "success",
                title: "cnPick Complete",
                text: response2.data.message,
              });

              const formData3 = {
                pickOrdersNumber: this.pickOrdersNumber,
                editor: String(this.userid),
                companyGroupsCode: this.companyGroupsCode,
              };

              const response3 = await axios.post(
                `${BASE_API_URL}/outbound-svc/exbdetails/cnShipItemTMO`,
                formData3,
                {
                  headers: { Authorization: "Bearer " + token.accessToken },
                }
              );
              // console.log(response3.data);

              if (response3.data.status != "success") {
                this.loading = false;
                this.$vs.notify({
                  position: "top-right",
                  color: "danger",
                  title: "Error from Backend",
                  text: response3.data.message,
                });

                this.errdata = response3.data.errdata;
                this.errorshow = true;
              } else {
                this.$vs.notify({
                  position: "top-right",
                  color: "success",
                  title: "Ship Complete",
                  text: response3.data.message,
                });

                if (this.$store.state.reportgrid == 0) {
                  this.$store.dispatch("setReportGrid", 1);
                } else {
                  this.$store.dispatch("setReportGrid", 0);
                }

                if (ENV_CHECK == "PROD") {
                  this.submitFDMS(response3.data.ReferenceNumber);
                }

                if (response3.data.jobType == "BM") {
                  this.submitFDMSPermit(response3.data.ReferenceNumber);
                }
              }
            }
          }
        }
      } catch (error) {
        this.data = [];
        this.total = 0;
        this.loading = false;
        // throw error;
        alert("กรุณาเข้าระบบอีกครั้ง");
        // this.$router.replace("/pages/login/");
      }
    },
    async submitFDMSPermit(ReferenceNumber) {
      try {
        const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

        const formData2 = {
          ReferenceNumber: ReferenceNumber,
        };

        const response2 = await axios.post(
          `${BASE_API_URL}/outbound-svc/cpermits/inboundPermitToFDMS`,
          formData2,
          {
            headers: { Authorization: "Bearer " + token.accessToken },
          }
        );

        if (response2.data.status != "success") {
          this.loading = false;
          this.$vs.notify({
            position: "top-right",
            color: "danger",
            title: "Error from Submit to FDMS",
            text: response2.data.message,
            fixed: true,
          });
        } else {
          const NETBAY_TOKEN = localStorage.getItem("NETBAY_TOKEN");
          //  console.log(NETBAY_TOKEN);
          try {
            // console.log('netlogin');
            const formData3 = {
              declarationNo: response2.data.message[0].dclnumber,
              inboundRequestNumber: [response2.data.message[0].number],
            };

            const response3 = await axios.post(
              PROX_URL + NETBAY_URL + `fz-webservice/api/inbound-permit`,
              // `https://kongapi.aotga.com/proxy-svc/https://uataotdc.netbay.co.th/fz-webservice/api/zone3-otherport`,
              // `https://uataotdc.netbay.co.th/fz-webservice/api/zone3-otherport`,
              // `/api/fz-webservice/api/zone3-otherport`,
              formData3,

              {
                headers: {
                  "Content-Type": "application/json",
                  token: NETBAY_TOKEN,
                },
              }
            );

            if (response3.status == "fail") {
              this.$vs.notify({
                position: "top-right",
                color: "danger",
                title: "Error",
                text: response3.message,
              });
            } else {
              this.$vs.notify({
                position: "top-right",
                color: "success",
                title: "Submit Success",
                text: response3.data.message,
              });

              const moment = require("moment-timezone");
              const timezone = "Asia/Bangkok";
              const now = moment().tz(timezone);

              const formData = {
                number: ReferenceNumber,
                code: response3.data.code,
                message: response3.data.message,
                createdAt: now,
              };

              await axios.post(
                `${BASE_API_URL}/outbound-svc/exborders/resFDMSInboundPermit`,
                formData,
                {
                  headers: { Authorization: "Bearer " + token.accessToken },
                }
              );
            }
          } catch (error) {
            // alert("กรุณาเข้าระบบอีกครั้ง");
            if (error.response) {
              // console.log(error.response.data);
              // console.log(error.response.data.message);
              // console.log(error.response.status);
              // console.log(error.response.headers);
              if (error.response.data.message == "Token has expired.") {
                this.$vs.notify({
                  position: "top-right",
                  color: "danger",
                  title: "Error",
                  text: error.response.data.message,
                });
              } else {
                this.$vs.notify({
                  position: "top-right",
                  color: "danger",
                  title: "Error",
                  text: error.response.data.message,
                });

                const moment = require("moment-timezone");
                const timezone = "Asia/Bangkok";
                const now = moment().tz(timezone);

                const formData = {
                  number: ReferenceNumber,
                  code: error.response.data.code,
                  message: error.response.data.message,
                  createdAt: now,
                };

                await axios.post(
                  `${BASE_API_URL}/outbound-svc/exborders/resFDMSInboundPermit`,
                  formData,
                  {
                    headers: { Authorization: "Bearer " + token.accessToken },
                  }
                );
              }
            }
          }
        }
      } catch (error) {
        alert("กรุณาเข้าระบบอีกครั้ง");
      }
    },
    async submitFDMS(ReferenceNumber) {
      const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));
      const NETBAY_TOKEN = localStorage.getItem("NETBAY_TOKEN");
      //  console.log(NETBAY_TOKEN);
      try {
        // console.log('netlogin');
        let confirmOutDate = moment().format("YYYYMMDD");
        let confirmOutTime = moment().format("HHmmssss");

        const formData3 = {
          transactionNo: ReferenceNumber,
          confirmOutDate: confirmOutDate,
          confirmOutTime: confirmOutTime,
        };

        const response3 = await axios.post(
          PROX_URL + NETBAY_URL + `fz-webservice/api/zone3-confirm-out`,
          // `https://kongapi.aotga.com/proxy-svc/https://uataotdc.netbay.co.th/fz-webservice/api/zone3-otherport`,
          // `https://uataotdc.netbay.co.th/fz-webservice/api/zone3-otherport`,
          // `/api/fz-webservice/api/zone3-otherport`,
          formData3,

          {
            headers: {
              "Content-Type": "application/json",
              token: NETBAY_TOKEN,
            },
          }
        );

        if (response3.status == "fail") {
          this.$vs.notify({
            position: "top-right",
            color: "danger",
            title: "Error",
            text: response3.message,
          });
        } else {
          this.$vs.notify({
            position: "top-right",
            color: "success",
            title: "Submit Success",
            text: response3.data.message,
          });

          const moment = require("moment-timezone");
          const timezone = "Asia/Bangkok";
          const now = moment().tz(timezone);

          const formData = {
            number: ReferenceNumber,
            code: response3.data.code,
            message: response3.data.message,
            createdAt: now,
          };

          await axios.post(
            `${BASE_API_URL}/outbound-svc/exborders/resFDMSMtoOut`,
            formData,
            {
              headers: { Authorization: "Bearer " + token.accessToken },
            }
          );
        }
      } catch (error) {
        // alert("กรุณาเข้าระบบอีกครั้ง");
        if (error.response) {
          // console.log(error.response.data);
          // console.log(error.response.data.message);
          // console.log(error.response.status);
          // console.log(error.response.headers);
          if (error.response.data.message == "Token has expired.") {
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Error",
              text: error.response.data.message,
            });
          } else {
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Error",
              text: error.response.data.message,
            });

            const moment = require("moment-timezone");
            const timezone = "Asia/Bangkok";
            const now = moment().tz(timezone);

            const formData = {
              number: ReferenceNumber,
              code: error.response.data.code,
              message: error.response.data.message,
              createdAt: now,
            };

            await axios.post(
              `${BASE_API_URL}/outbound-svc/exborders/resFDMSMtoOut`,
              formData,
              {
                headers: { Authorization: "Bearer " + token.accessToken },
              }
            );
          }
        }
      }
    },
    async resendSubmitFDMS() {
      const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));
      const NETBAY_TOKEN = localStorage.getItem("NETBAY_TOKEN");
      //  console.log(NETBAY_TOKEN);
      try {
        // console.log('netlogin');
        const formData = {
          number: this.recid,
        };

        const response = await axios.post(
          `${BASE_API_URL}/outbound-svc/exborders/zone3ConfirmOut`,
          formData,
          {
            headers: { Authorization: "Bearer " + token.accessToken },
          }
        );

        if (response.data.status != "success") {
          this.$vs.notify({
            position: "top-right",
            color: "danger",
            title: "Error from MTMS",
            text: response.data.message,
          });
        } else {
          let ReferenceNumber = response.data.exbdetail.exbordersNumber;
          let confirmOutDate = moment(response.data.exbdetail.out_at).format(
            "YYYYMMDD"
          );
          let confirmOutTime = moment(response.data.exbdetail.out_at).format(
            "HHmmssss"
          );

          // console.log(ReferenceNumber);
          // console.log(confirmOutDate);
          // console.log(confirmOutTime);

          const formData3 = {
            transactionNo: ReferenceNumber,
            confirmOutDate: confirmOutDate,
            confirmOutTime: confirmOutTime,
          };

          const response3 = await axios.post(
            PROX_URL + NETBAY_URL + `fz-webservice/api/zone3-confirm-out`,
            // `https://kongapi.aotga.com/proxy-svc/https://uataotdc.netbay.co.th/fz-webservice/api/zone3-otherport`,
            // `https://uataotdc.netbay.co.th/fz-webservice/api/zone3-otherport`,
            // `/api/fz-webservice/api/zone3-otherport`,
            formData3,

            {
              headers: {
                "Content-Type": "application/json",
                token: NETBAY_TOKEN,
              },
            }
          );

          if (response3.status == "fail") {
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Error",
              text: response3.message,
            });
          } else {
            this.$vs.notify({
              position: "top-right",
              color: "success",
              title: "Submit Success",
              text: response3.data.message,
            });

            const moment = require("moment-timezone");
            const timezone = "Asia/Bangkok";
            const now = moment().tz(timezone);

            const formData = {
              number: ReferenceNumber,
              code: response3.data.code,
              message: response3.data.message,
              createdAt: now,
            };

            await axios.post(
              `${BASE_API_URL}/outbound-svc/exborders/resFDMSMtoOut`,
              formData,
              {
                headers: { Authorization: "Bearer " + token.accessToken },
              }
            );
          }
        }
      } catch (error) {
        // alert("กรุณาเข้าระบบอีกครั้ง");
        if (error.response) {
          // console.log(error.response.data);
          // console.log(error.response.data.message);
          // console.log(error.response.status);
          // console.log(error.response.headers);
          if (error.response.data.message == "Token has expired.") {
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Error",
              text: error.response.data.message,
            });
          } else {
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Error",
              text: error.response.data.message,
            });

            const moment = require("moment-timezone");
            const timezone = "Asia/Bangkok";
            const now = moment().tz(timezone);

            const formData = {
              number: this.exbordersNumber,
              code: error.response.data.code,
              message: error.response.data.message,
              createdAt: now,
            };

            await axios.post(
              `${BASE_API_URL}/outbound-svc/exborders/resFDMSMtoOut`,
              formData,
              {
                headers: { Authorization: "Bearer " + token.accessToken },
              }
            );
          }
        }
      }
    },
    goPick() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Do you want to submitFDMSPermit? ",
        accept: this.goPickAll,
      });
    },
    async goPickAll() {
      this.submitFDMSPermit(this.exbordersNumber);
    },
    goPickMain() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Do you want to Resend MTO Confirm OUT? ",
        accept: this.goMtoConfirmOut,
      });
    },
    async goMtoConfirmOut() {
      this.resendSubmitFDMS();
    },
    goShip() {
      this.$router.replace("/ships");
    },
    goAllocate() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Do you want to Allocate Picking? ",
        accept: this.goAllocatePick,
      });
    },
    goAllocatePick() {
      const formData = {
        token: localStorage.getItem("token"),
        dbname: localStorage.getItem("dbname"),
        exbdetails: this.recid,
      };
      axios
        .post("/ApiExbcnpick", formData)
        .then((res) => {
          if (res.data.status == "error") {
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Print Error",
              text: res.data.message,
              fixed: true,
            });
          } else {
            let url = localStorage.getItem("appdb");
            let dbname = localStorage.getItem("dbname");
            window.open(
              url + "api/ApiInbdetailsPrint/" + this.recid + "/" + dbname
            );
          }
        })
        .catch((err) => {
          this.$vs.notify({
            position: "top-right",
            color: "danger",
            title: "Deleted Error",
            text: err,
          });
        });
    },
    goPrint() {
      const formData = {
        token: localStorage.getItem("token"),
        dbname: localStorage.getItem("dbname"),
        exbdetails: this.recid,
      };
      axios
        .post("/ApiPrePickingPrint", formData)
        .then((res) => {
          if (res.data.status == "error") {
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Print Error",
              text: res.data.message,
              fixed: true,
            });
          } else {
            let url = localStorage.getItem("appdb");
            let dbname = localStorage.getItem("dbname");
            window.open(
              url + "api/ApiPickingPrint/" + this.recid + "/" + dbname
            );
          }
        })
        .catch((err) => {
          this.$vs.notify({
            position: "top-right",
            color: "danger",
            title: "Deleted Error",
            text: err,
          });
        });
    },
    regrid() {
      // this.$router.replace("/Inbdetails/0");
      // this.masrec = "0";
      this.gridshow = false;
      this.gridshow2 = false;
      this.errorshow = false;
      setTimeout(() => {
        this.grid();
      }, 1000);
    },
    cusEdit() {
      this.addshow = true;
      this.gridshow = false;
      this.gridshow2 = false;
      this.btndis = false;
      this.errshow = false;
      this.errorshow = false;
      this.acstate = "EDIT";
    },
    cusDel() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Do you want to Delete? " + this.recid,
        accept: this.acceptAlert,
      });
    },
    async acceptAlert() {
      this.btndis = false;

      try {
        const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));
        this.readonly = true;

        if (token) {
          const formData = {
            number: this.recid,
            editor: String(this.userid),
            companyGroupsCode: this.companyGroupsCode,
          };

          const response = await axios.post(
            `${BASE_API_URL}/outbound-svc/exbdetails/delete`,
            formData,
            {
              headers: { Authorization: "Bearer " + token.accessToken },
            }
          );
          // console.log(response.data);

          if (response.data.status != "success") {
            this.loading = false;
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Error from Backend",
              text: response.data.message,
            });
          } else {
            if (this.$store.state.reportgrid == 0) {
              this.$store.dispatch("setReportGrid", 1);
            } else {
              this.$store.dispatch("setReportGrid", 0);
            }

            this.$vs.notify({
              position: "top-right",
              color: "success",
              title: "Deleted Complete",
              text: response.data.message,
            });
          }
        }
      } catch (error) {
        this.data = [];
        this.total = 0;
        this.loading = false;
        // throw error;
        alert("กรุณาเข้าระบบอีกครั้ง");
        // this.$router.replace("/pages/login/");
      }
      // this.gridshow = false;
      // this.gridshow = true;
    },
    getXY(event) {
      this.curX = event.clientX;
      this.curY = event.clientY;

      // console.log(this.curX);
      // console.log(this.curY);
    },
    hideFab() {
      this.btndis = false;
    },
    async checkProfiles() {
      const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

      if (token) {
        const decoded = JSON.parse(
          Buffer.from(token.accessToken.split(".")[1], "base64").toString()
        );

        // console.log(decoded);

        try {
          // console.log(responseponse.data);
          this.userid = decoded.userId;
          this.userRole = decoded.userRole;

          this.businessPartnersCode = decoded.businessPartnersCode;
          this.companyGroupsCode = decoded.companyGroupsCode;
          this.walletId = decoded.walletId;
        } catch (error) {
          alert("กรุณาเข้าระบบอีกครั้ง");
          await this.$router.replace("/");
        }
      } else {
        alert("กรุณาเข้าระบบอีกครั้ง");
        await this.$router.replace("/");
      }
    },
  },
  components: {
    aggrid,
    aggrid2,
    exbdadd,
    exberror,
  },
  created() {
    this.checkProfiles();
    // console.log(this.inborders_number);
    this.masrec = this.exbordersNumber;
    // console.log(this.masrec);
    if (this.masrec != 0) {
      this.grid();
    }
  },
};
</script>

<style scoped>
.fab-wrapper {
  position: fixed;
  left: 100px;
  top: 500px;
  z-index: 5;
  display: flex;
  flex-direction: center;
  align-items: center;
}
.fab {
  background-color: rgb(231, 55, 55);
}
</style>
